module.exports = __webpack_public_path__ + "img/close.e598d67d.svg";